module.exports = __webpack_public_path__ + "static/media/6.72ef9193.png";